import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input()
  textarea = false

  @Input()
  value = ''

  @Input()
  name = ''

  @Input()
  isRequire

  @Input()
  alignRight = false

  @Input()
  lightTheme = false

  @Input()
  isSpecial = false

  @Output()
  fieldValue = new EventEmitter

  val: any

  setFloat: boolean

  inflaPattern = [/\d/,'.',/\d/,/\d/]

  constructor() { }

  ngOnInit() {
  }

  setValue() {
    if (this.val == undefined) {
      this.fieldValue.emit(0)
    } else {
      this.fieldValue.emit(this.val.replace(/,/g, ''))
    }
  }

  addCommas(target) {
    let rep = target.replace(/,/g, '')
    this.val = rep.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

}
